"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
exports.transformOldStructureToNew = exports.displayDeprecatedWarnings = void 0;
exports.displayDeprecatedWarnings = function (dataDef) {
    if (typeof dataDef.displayType === 'string') {
        console.warn("Usage of `displayType: 'toggle' | 'update' | 'view' is deprecated and won't be supported in the future. Please use 'displayType: { editType: 'toggle' | 'update' | 'view' | undefined }`");
    }
    if (dataDef.showDelete !== undefined) {
        console.warn("Usage of 'showDelete' is deprecated and won't be supported in the future. Please use 'displayType: { delete: true|false|undefined }' instead.");
    }
};
exports.transformOldStructureToNew = function (dataDef) {
    var newDataDef = {
        fields: dataDef.fields,
        urlPrefix: dataDef.urlPrefix,
        addRedirect: dataDef.addRedirect
    };
    if (typeof dataDef.displayType === 'string') {
        newDataDef.displayType = {
            editType: dataDef.displayType
        };
    }
    else {
        newDataDef.displayType = dataDef.displayType;
    }
    if (dataDef.showDelete !== undefined) {
        newDataDef.displayType = __assign(__assign({}, newDataDef.displayType), { "delete": dataDef.showDelete });
        newDataDef.showDelete = undefined;
    }
    return __assign(__assign({}, dataDef), newDataDef);
};
